const pn = (value) => {
  const match = typeof value === "string" && value.match(/^(\d{6,15})(?::\d+)?@(s\.whatsapp\.net|c\.us|hosted)$/);
  return match ? match[1] : null;
};

const lidUser = (contact) => {
  for (const value of [contact?.lid, contact?.remoteJid]) {
    const match = typeof value === "string" && value.match(/^(\d+)(?::\d+)?@(lid|hosted\.lid)$/);
    if (match) return match[1];
  }
  return null;
};

export const contactPhone = (contact) => {
  if (contact?.isGroup) return null;
  const known = pn(contact?.jid) || pn(contact?.remoteJid);
  if (known) return known;
  const number = String(contact?.number || "");
  if (lidUser(contact) === number) return null;
  return /^\d{6,15}$/.test(number) ? number : null;
};

export const unresolvedWhatsAppContact = (contact) =>
  !contact?.isGroup && Boolean(lidUser(contact)) && !contactPhone(contact);

export const contactDisplayName = (contact) => {
  const name = String(contact?.name || "").trim();
  if (contact?.isGroup || (contact?.channel && contact.channel !== "whatsapp")) return name || "-";
  if (!name || (/^[\d\s+().-]+$/.test(name) && name.replace(/\D/g, "").length >= 6) || /@(lid|hosted\.lid)$/.test(name) || /^Contato WhatsApp(?: #\d+)?$/.test(name)) {
    return `Contato WhatsApp #${contact.id}`;
  }
  return name;
};

export const contactIdentityReview = (contact) =>
  !contact?.isGroup && (contact?.identityReviewStatus === "pending" ||
    (!["linked", "dismissed"].includes(contact?.identityReviewStatus) && Boolean(lidUser(contact)) && contactPhone(contact) && String(contact.number || "") === lidUser(contact)));

export const loadScopedContactUpdate = async (contact, user, load) => {
  if (!contact?.id || Number(contact.companyId) !== Number(user.companyId)) return null;
  const result = user.profile === "admin" ? contact : await load(contact.id);
  return Number(result?.companyId) === Number(user.companyId) ? result : null;
};

export const contactPhoneLabel = (contact, format, hide = false) => {
  if (contact?.isGroup) return contact.number || "-";
  if (contact?.channel && contact.channel !== "whatsapp") return format(contact.number) || contact.number || "-";
  const phone = contactPhone(contact);
  if (!phone) return "Telefone n\u00e3o informado";
  const formatted = format(phone) || phone;
  return hide ? `${formatted.slice(0, -6)}**-**${formatted.slice(-2)}` : formatted;
};
